// Copyright 2016 Sorama B.V.

import { IOverride } from "overrides/IOverride";

export interface IEventRegistrationListener {
    eventListenerAdded(target: EventTarget, eventName: string, eventHandler: EventListener): void;
    eventListenerRemoved(target: EventTarget, eventName: string, eventHandler: EventListener): void;
}

// NOTE: There is still a bug in this class causing aurelia to not properly dispose delegates, please fix before using.
export class EventInterceptorOverride implements IOverride {
    constructor() {}

    private eventRegistrationListeners: IEventRegistrationListener[] = [];

    public register(listener: IEventRegistrationListener): void {
        this.eventRegistrationListeners.push(listener);
    }

    public unregister(listener: IEventRegistrationListener): void {
        this.eventRegistrationListeners.splice(this.eventRegistrationListeners.indexOf(listener), 1);
    }

    //#region IOverride Members
    public use(): IOverride {
        const $this = this;

        const eventHandlers: { originalEventHandler: EventListener; replacementEventHandler: EventListener }[] = [];
        // See: https://css-tricks.com/capturing-all-events/
        const oldAddEventListener = EventTarget.prototype.addEventListener;
        EventTarget.prototype.addEventListener = function (eventName: string, eventHandler: EventListener) {
            $this.eventRegistrationListeners.forEach((x: IEventRegistrationListener) =>
                x.eventListenerAdded(this, eventName, eventHandler)
            );

            const replacementEventHandler = function (event: Event) {
                eventHandler(event);
            };

            eventHandlers.push({
                originalEventHandler: eventHandler,
                replacementEventHandler: replacementEventHandler,
            });

            oldAddEventListener.call(this, eventName, replacementEventHandler);
        };

        const oldRemoveEventListener = EventTarget.prototype.removeEventListener;
        EventTarget.prototype.removeEventListener = function (eventName: string, eventHandler: EventListener) {
            $this.eventRegistrationListeners.forEach((x: IEventRegistrationListener) =>
                x.eventListenerRemoved(this, eventName, eventHandler)
            );

            const handlerSetIndex = eventHandlers.findIndex((x) => x.originalEventHandler === eventHandler);
            if (handlerSetIndex === undefined) {
                console.error("Cannot find original event handler");
                return;
            }
            const replacementHandler = eventHandlers[handlerSetIndex].replacementEventHandler;

            oldRemoveEventListener.call(this, eventName, replacementHandler);
            eventHandlers.splice(handlerSetIndex, 1);
        };

        return this;
    }
    //#endregion
}
